import React, { useMemo, useState } from "react";
import { Modal, Label, ModalHeader, Card, CardBody, Row, Col, Alert } from 'reactstrap';
import defaultUserImg from "../../../assets/images/defaultuserimgdark.png";
import axios from "axios";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import Breadcrumb from "Components/Common/Breadcrumb";
import TableContainer from "Components/Common/TableContainer";


interface column {
    header: string;
    accessorKey?: string;
    accessorFn?: (row: any) => string;
    enableColumnFilter: boolean;
    enableSorting: boolean;
    cell?: (info: any) => React.ReactNode;
}

interface PEClientsListProps {
    domain?: number;
}

export const PEClientsList = ({ domain }: PEClientsListProps) => {

    const [assignmentsData, setAssignmentData] = useState<any[]>([]);

    const [showloader, setshowloader] = useState(true);
    const [alertMsgg, setAlertMsgg] = useState<any>({ open: false, type: "success", content: "Messages here.", time: "2500" });
    
    // Get user role from localStorage
    const userRole = localStorage.getItem("userole_");

    const formatDate = (dateStr: string) => {
        if (!dateStr) return '';
        const d = new Date(dateStr);
        return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')} ${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`;
    };

    const handleAlertMsggClose = (event?: React.SyntheticEvent | Event, reason?: string) => {
        if (reason === "clickaway") { return; }
        setAlertMsgg({ ...alertMsgg, open: false });
    };

    const fetch_assignments = async () => {
        console.log("Fetching assignments...");

        try {
            setshowloader(true);
            const params: any = {};
            if (domain) {
                params.domain = domain;
            }
            
            const response = await axios.get(
                `/assignments/listAssignments`,
                { params },
                { withCredentials: true }
            );
            if (response && response.status === "SENT") {
                setAssignmentData(response.assignments || []);
            }
            setshowloader(false);
        } catch (error: any) {
            if (error.response) {
                if ([401, 422].includes(error.response.status)) {
                    setAlertMsgg({ ...alertMsgg, open: true, content: error.response.data?.error || "Error occurred", type: "error" });
                } else if (error.response.status === 403) {
                    setAlertMsgg({ ...alertMsgg, open: true, content: "Session expired!", type: "error" });
                    setTimeout(() => { window.location.href = "/logout"; }, 2000);
                } else {
                    setAlertMsgg({ ...alertMsgg, open: true, content: "An error occurred", type: "error" });
                }
            } else {
                setAlertMsgg({ ...alertMsgg, open: true, content: "Network error", type: "error" });
            }
            setshowloader(false);
        }
    };

    useEffect(() => {
        fetch_assignments();
    }, [domain]);

    const columns: column[] = useMemo(
        () => {
            const baseColumns = [
                {
                    header: 'S.No',
                    enableColumnFilter: false,
                    enableSorting: false,
                    cell: ({ row }) => row.index + 1,
                },
                userRole === 'prt' || userRole === 'emp' || userRole === 'adm' ? {
                    header: 'Client',
                    enableColumnFilter: false,
                    enableSorting: true,
                    cell: ({ row }) => {
                        const client = row.original.client;
                        const { created_at } = row.original;

                        return (
                            <div className="d-flex align-items-center">
                                <div>
                                    <div className="fw-medium text-capitalize">{client.name}</div>
                                    <div className="font-size-12">{client.email}</div>
                                    <div className="font-size-10">Created On: {formatDate(created_at)}</div>
                                </div>
                            </div>
                        );
                    },
                }: {
                    header: userRole==="cst"?"Point of Contact":"Partner/Employee",
                    enableColumnFilter: false,
                    enableSorting: true,
                    cell: ({ row }) => {
                        const assignee = row.original.assignee;

                        return (
                            <div className="d-flex align-items-center">
                                <div>
                                    <div className="fw-medium text-capitalize">{assignee.name}</div>
                                    <div className="font-size-12">{assignee.email}</div>
                                </div>
                            </div>
                        );
                    },
                },
            ];

            // Add "Assigned To" column only for admin users
            if (userRole === 'adm') {
                baseColumns.push({
                    header: 'Assigned To',
                    enableColumnFilter: false,
                    enableSorting: true,
                    cell: ({ row }) => {
                        const assignee = row.original.assignee;
                        if (!assignee) {
                            return <div className="text-muted">Not assigned</div>;
                        }
                        
                        return (
                            <div>
                                <div className="fw-medium text-capitalize">{assignee.name}</div>
                                <div className="font-size-12">{assignee.email}</div>
                                <div className="font-size-12">{assignee.phone}</div>
                                <div className="font-size-10">
                                    <span className={`badge ${row.original.assignee_type === 'prt' ? 'bg-primary' : 'bg-info'}`}>
                                        {row.original.assignee_type === 'prt' ? 'Partner' : 'Employee'}
                                    </span>
                                </div>
                            </div>
                        );
                    },
                });
            }

            // Add Action column
            baseColumns.push({
                header: 'Action',
                enableColumnFilter: false,
                enableSorting: true,
                cell: ({ row }) => {

                    return (
                        <div className="d-flex gap-2">
                            <Link to={`/assignment?assignment_id=${row.original.id}`} className="btn btn-primary  btn-sm">
                                <i className="far fa-eye me-1"></i>{" "}
                                View
                            </Link>
                        </div>
                    );
                },
            });

            return baseColumns;
        },
        [userRole]
    );

    document.title = "Clients | BizServe";

    return (
        <div className="">
            <div className="container-fluid">
                <Breadcrumb title="Task Management" breadcrumbItem={userRole === 'prt' || userRole === 'emp' ? 'Clients' : userRole === 'cst' ? 'Tasks & Progress' : 'Assignments'} />
                {alertMsgg.open && (
                    <Alert
                        color={alertMsgg.type === "success" ? "success" : "danger"}
                        toggle={handleAlertMsggClose}
                        fade={false}
                        style={{ fontWeight: "bold" }}
                    >
                        {alertMsgg.content}
                    </Alert>
                )}
                <div className="loaderContainer" hidden={!showloader}>
                    <div className="spinner">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                </div>
                <TableContainer
                    columns={columns}
                    data={assignmentsData}
                    isGlobalFilter={true}
                    isPagination={true}
                    SearchPlaceholder="Search By Name..."
                    pagination="pagination"
                    paginationWrapper='dataTables_paginate paging_simple_numbers'
                    tableClass="table-bordered dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
                />
            </div>
        </div>
    );
}